import { render, staticRenderFns } from "./ChatExtensionOnboarding.vue?vue&type=template&id=efe1ca10&scoped=true&"
import script from "./ChatExtensionOnboarding.vue?vue&type=script&lang=js&"
export * from "./ChatExtensionOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe1ca10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe1ca10')) {
      api.createRecord('efe1ca10', component.options)
    } else {
      api.reload('efe1ca10', component.options)
    }
    module.hot.accept("./ChatExtensionOnboarding.vue?vue&type=template&id=efe1ca10&scoped=true&", function () {
      api.rerender('efe1ca10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ChatExtensionOnboarding.vue"
export default component.exports